import { Component, OnInit } from '@angular/core';
import { OrganisationsService } from '../../services';
import { ActivatedRoute, Params } from '@angular/router';
import { IContractTypeHistory } from '../../interfaces/contract-type-history.interface';
import { BBWTMessageService } from '../../services';

@Component({
  selector: 'manage-contract-type-history',
  templateUrl: './manage-contract-type-history.component.html',
  styleUrls: ['./manage-contract-type-history.component.scss'],
})
export class ManageContractTypeHistoryComponent implements OnInit {
  constructor(
    private organisationService: OrganisationsService,
    private route: ActivatedRoute,
    private messageService: BBWTMessageService,
  ) {}

  organisationId: number;
  histories: IContractTypeHistory[];
  selectedHistory: IContractTypeHistory;
  loading = true;

  selectedDate: Date;
  isEndDate = false;
  showDateAdjust: any;

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.organisationId = params['id'];

      this.organisationService
        .getOrganisationContractTypeHistory(this.organisationId)
        .then((result) => {
          this.histories = result;
          this.loading = false;
        });
    });
  }

  editDate(item: IContractTypeHistory, isEndDate: boolean) {
    this.selectedHistory = item;
    this.selectedDate = new Date(isEndDate ? item.endDate : item.startDate); //new Date(Date.parse( isEndDate ? item.endDate : item.startDate ))
    this.isEndDate = isEndDate;
    this.showDateAdjust = true;
  }

  closeEditDialog() {
    this.showDateAdjust = false;
  }

  private historyOverlap(): boolean {
    for (let i = this.histories.length - 1; i >= 0; i--) {
      if (i > 0) {
        // startDate should be on or after end-date of previous record
        let endDate = new Date(this.histories[i - 1].endDate || new Date());
        let startDate = new Date(this.histories[i].startDate || new Date());

        if (endDate.getTime() < startDate.getTime()) {
          return true;
        }
      }
    }

    return false;
  }

  updateHistory() {
    this.closeEditDialog();

    if (this.isEndDate) {
      this.selectedHistory.endDate = new Date(this.selectedDate);
    } else {
      this.selectedHistory.startDate = new Date(this.selectedDate);
    }

    let start = new Date(this.selectedHistory.startDate);
    let end = this.selectedHistory.endDate ? new Date(this.selectedHistory.endDate) : null;

    // prevent simple overlap on this record
    if (end && end.getTime() <= start.getTime()) {
      end = start;
    }

    this.selectedHistory.startDate = start;
    this.selectedHistory.endDate = end;

    if (this.historyOverlap()) {
      this.messageService.ShowWarning(
        'Warning',
        'One or more of the contract history records overlap',
      );
    }

    this.organisationService.updateOrganisationContractTypeHistory([this.selectedHistory]);
  }
}
